
import React from "react";

import Main from "./Main/main";


function Form() {
    return (
        <div>
            <Main />
        </div>
    );
}

export default Form;
